import { useState } from 'react';
import { api, ErrorApi, type Sesion } from '../api';
import { CampoContrasena } from './CampoContrasena';

/**
 * Pantalla de acceso.
 *
 * No guarda nada: la credencial se cambia por una cookie de sesión que el
 * navegador no puede leer. Si la pestaña se recarga, el estado se recupera
 * preguntándole al portal quién es, no leyendo algo del almacenamiento local.
 */
export function Acceso({
  onEntrar,
  onSegundoFactor,
  onRecuperar,
}: {
  onEntrar: (sesion: Sesion) => void;
  /** La contraseña era correcta pero falta el segundo factor. */
  onSegundoFactor: () => void;
  onRecuperar: () => void;
}) {
  const [email, setEmail] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: React.FormEvent): Promise<void> {
    evento.preventDefault();
    if (!email.trim() || !contrasena) return;

    setEnviando(true);
    setError(null);
    try {
      const respuesta = await api.entrar(email.trim(), contrasena);
      // La contraseña ya no se necesita: el portal dejó una cookie a medias.
      setContrasena('');
      // El estrechamiento por 'requiere2fa' in ... no lo hace TypeScript a
      // través de una función auxiliar, así que se comprueba acá mismo.
      if ('requiere2fa' in respuesta) onSegundoFactor();
      else onEntrar(respuesta);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'no se pudo contactar el portal');
      setContrasena('');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="acceso">
      <h1>VoxObservability</h1>
      <p>Ingresa con tu cuenta.</p>

      <form onSubmit={(e) => void enviar(e)}>
        <label>
          <span>Correo</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <CampoContrasena
          etiqueta="Contraseña"
          valor={contrasena}
          onCambio={setContrasena}
          autoComplete="current-password"
        />

        <button type="submit" disabled={enviando}>
          {enviando ? 'Verificando…' : 'Entrar'}
        </button>
      </form>

      {error && <p className="error">{error}</p>}

      <button className="enlace bajo" onClick={onRecuperar}>
        Olvidé mi contraseña
      </button>
    </div>
  );
}
